import { Component } from '@angular/core';
import { ConfigService } from 'src/app/config.service';
import { SettingsService } from 'src/app/settings/settings.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  connectionState = { class: 'text-danger', label: 'Verbinde zum Server...' };
  serverVersion = 'x.x.x';
  version = 'x.x.x';

  constructor(private settingsService: SettingsService, private configService: ConfigService,
    // public sseService: SSEService
  ) {
    this.version = this.configService.configData.appVersion;
    this.settingsService.getServerVersion().subscribe(
      version => {
        this.serverVersion = version.number;
      }
    );
    // this.sseService.connectionState$.subscribe((state) => {

    //   switch (state) {
    //     case 'connected':
    //       this.connectionState = { class: 'text-success', label: 'verbunden' };
    //       break;
    //     case 'connecting':
    //       this.connectionState = { class: 'text-warning', label: 'Verbinde zum Server...' };
    //       break;
    //     case 'unavailable':
    //       this.connectionState = { class: 'text-danger', label: 'Server nicht erreichbar' };
    //       break;
    //     default:
    //       this.connectionState = { class: 'text-secondary', label: 'unbekannt' };
    //   }
    // });
  }

}
